<template>
  <!-- 悬浮下拉面板，定位由父容器控制 -->
  <div class="help-faq-pop" v-show="visible">
    <!-- <div class="help-item" @click="handleItemClick('hotline')">
      <i class="el-icon-phone-outline item-icon"></i>
      <div class="item-text">
        <div class="title">热线电话</div>
        <div class="desc">4008013260（7*24小时服务热线）</div>
      </div>
    </div> -->
    <!-- <div class="help-item" @click="handleItemClick('preSale')">
      <i class="el-icon-bell item-icon"></i>
      <div class="item-text">
        <div class="title">售前咨询</div>
        <div class="desc">火爆活动欢迎了解，专属售前客服为您服务</div>
      </div>
    </div> -->
    <!-- <div class="help-item" @click="handleItemClick('afterSale')">
      <i class="el-icon-service item-icon"></i>
      <div class="item-text">
        <div class="title">售后在线</div>
        <div class="desc">在线实时沟通，快速解决您的问题</div>
      </div>
    </div> -->
    <div class="help-item" @click="handleItemClick('selfHelp')">
      <i class="el-icon-bell item-icon"></i>
      <div class="item-text">
        <div class="title">系统帮助文档</div>
        <div class="desc">各个环节操作文档说明</div>
      </div>
    </div>
    <div class="help-item" @click="handleItemClick('feedback')">
      <i class="el-icon-info item-icon"></i>
      <div class="item-text">
        <div class="title">聆听·建议反馈</div>
        <div class="desc">欢迎提交您的建议</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HelpFaq",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleItemClick(type) {
      // 向外抛出事件，父组件做跳转/弹窗逻辑
      this.$emit('faq-click', type);
    }
  }
}
</script>
<style scoped>
.help-item {
  display: flex;
  padding: 12px 16px;
  cursor: pointer;
  align-items: flex-start;
  gap: 12px;
}
.help-item:hover {
  background-color: #f5f7fa;
}
.item-icon {
  font-size: 20px;
  color: #606266;
  flex-shrink: 0;
  margin-top: 2px;
}
.item-text {
  flex: 1;
}
.title {
  font-size: 15px;
  color: #303133;
  margin-bottom: 4px;
}
.desc {
  font-size: 13px;
  color: #909399;
}
</style>
